(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Separate instances keep desktop and mobile accordion state independent.
  if (!customElements.get('balloons-menu-accordion')) {
    customElements.define('balloons-menu-accordion', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const desktopItem = this.closest('.menu-list__list-item');
        if (desktopItem) {
          desktopItem.addEventListener('pointerenter', () => this.fitDesktopMenu(), options);
          desktopItem.addEventListener('focusin', () => this.fitDesktopMenu(), options);
          window.addEventListener('resize', () => this.fitDesktopMenu(), options);
        }
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const summary = event.target.closest('summary');
          if (!summary || summary.closest('balloons-menu-accordion') !== this) return;
          if (event.target.closest('a, button')) return;
          const branch = summary.parentElement;
          if (!(branch instanceof HTMLDetailsElement)) return;
          event.preventDefault();
          if (branch.open) this.closeBranch(branch);
          else this.openBranch(branch);
        }, options);
        this.addEventListener('pointerover', (event) => {
          if (!this.hasAttribute('data-hover') || event.pointerType !== 'mouse' ||
              !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          if (!(event.target instanceof Element)) return;
          const summary = event.target.closest('summary');
          if (!summary || summary.closest('balloons-menu-accordion') !== this) return;
          if (event.relatedTarget instanceof Node && summary.contains(event.relatedTarget)) return;
          const branch = summary.parentElement;
          if (branch instanceof HTMLDetailsElement) this.openBranch(branch);
        }, options);
        // Also handle native/programmatic changes, including accessibility tools.
        this.addEventListener('toggle', (event) => {
          const branch = event.target;
          if (!(branch instanceof HTMLDetailsElement) ||
              branch.closest('balloons-menu-accordion') !== this) return;
          if (branch.open) this.openBranch(branch);
          else this.closeBranch(branch);
        }, { ...options, capture: true });
      }
      closeBranch(branch) {
        branch.open = false;
        branch.querySelectorAll('details[open]').forEach(child => { child.open = false; });
      }
      openBranch(branch) {
        const parentBranch = branch.parentElement.closest('details');
        this.querySelectorAll('details[open]').forEach(other => {
          if (other !== branch && other.parentElement.closest('details') === parentBranch) {
            this.closeBranch(other);
          }
        });
        branch.open = true;
        this.fitDesktopMenu();
      }
      fitDesktopMenu() {
        const menu = this.closest('.menu-list--simple .balloons-fixed');
        if (!menu || !menu.offsetParent) return;
        const origin = menu.offsetParent.getBoundingClientRect();
        const left = Math.max(12, Math.min(origin.left - 8, window.innerWidth - menu.offsetWidth - 12));
        menu.style.left = `${left - origin.left}px`;
        menu.style.right = 'auto';
        this.querySelectorAll('.balloons-fixed__category[open] > .balloons-fixed__content').forEach(panel => {
          panel.style.setProperty('--balloons-panel-shift', '0px');
          const rect = panel.getBoundingClientRect();
          const shift = rect.left < 12 ? 12 - rect.left : Math.min(0, window.innerWidth - 12 - rect.right);
          panel.style.setProperty('--balloons-panel-shift', `${shift}px`);
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  if (!customElements.get('balloona-mobile-menu')) {
    customElements.define('balloona-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        // Waiting a frame also supports upgrades while the HTML is being parsed.
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-menu-open]');
        if (!dialog || !trigger) return;
        const close = () => { if (dialog.open) dialog.close(); };
        trigger.addEventListener('click', () => {
          if (!dialog.open) dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('[data-menu-close]').addEventListener('click', close, options);
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
        }, options);
        dialog.addEventListener('click', (event) => {
          // Only clicks outside the panel are backdrop clicks.
          if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right ||
                event.clientY < rect.top || event.clientY > rect.bottom) close();
          }
          if (event.target instanceof Element && event.target.closest('a[href]')) close();
        }, options);
        const desktop = matchMedia('(min-width: 750px)');
        desktop.addEventListener('change', () => {
          if (desktop.matches && getComputedStyle(this.parentElement).display === 'none') close();
        }, options);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        const dialog = this.querySelector('dialog');
        if (dialog?.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
